<template>
  <div
    id="sidebar"
    class="h-full w-16 menu bg-gray-200 text-white px-4 flex items-center nunito static fixed"
  >
    <ul class="list-reset">
      <BaseSidebarAction
        v-for="action in userModeActions"
        :key="`sidebar_action_${action.id}`"
        :icon="action.icon"
        :title="action.title"
        :active="asideId === action.id"
        @click.prevent="toggleAsideContent(action)"
      />
    </ul>
  </div>
</template>

<script>
import { get, filter, includes } from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import BaseSidebarAction from '@/components/sidebar/_base-sidebar-action.vue';

export default {
  components: { BaseSidebarAction },

  data() {
    return {
      actions: [
        // {
        //   id: 'stats_section',
        //   icon: 'tachometer-alt',
        //   component: 'AsideStatsSection',
        //   title: this.$t('messages.experiment_stats')
        // },
        {
          id: 'my_score_section',
          key: 'section',
          icon: 'user',
          component: 'AsideMyScoreSection',
          title: this.$t('messages.my_score'),
        },
        // {
        //   id: 'my_team_section',
        //   icon: 'users',
        //   component: 'AsideMyTeamSection',
        //   title: this.$t('messages.my_team')
        // },
        {
          id: 'artifact_dataset_comments',
          key: 'comment',
          icon: 'comment',
          component: 'AsideCommentsSection',
          title: this.$tc('messages.comment', 2),
        },
        {
          id: 'leaderboard_section',
          key: 'leaderboard',
          icon: 'chart-bar',
          component: 'AsideLeaderBoardSection',
          title: this.$tc('messages.leader_board', 2),
        },
        // {
        //   id: 'settings_section',
        //   icon: 'cog',
        //   component: 'AsideSettingsSection',
        //   title: this.$t('messages.settings')
        // }
      ],
    };
  },

  computed: {
    ...mapGetters('civium', ['asideId']),
    ...mapGetters('auth', ['modeActions']),

    /**
     * Mode Actions that will be displayed.
     *
     * @return {Array}
     */
    userModeActions() {
      return filter(this.actions, (action) =>
        includes(this.modeActions, action.key)
      );
    },
  },

  methods: {
    ...mapActions('civium', ['openAside', 'closeAside']),

    /**
     * Toggle the current aside view and load the component if
     * needed.
     *
     * @param aside
     */
    toggleAsideContent(aside) {
      if (aside.id === this.asideId) {
        return this.closeAside();
      }

      return this.openAside(aside);
    },
  },
};
</script>

<style>
#sidebar {
  transition: ease-in-out all 0.3s;
  z-index: 9;
}

#sidebar span {
  opacity: 0;
  position: absolute;
  transition: ease-in-out all 0.1s;
}

#sidebar:hover {
  width: 150px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

#sidebar:hover span {
  opacity: 1;
}
</style>
